import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import cn from "classnames";
import { buttonVariants } from "theme/buttonVariants";

const Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faInfoCircle} size="6x" />
    </div>
);

const CardsComponent = ({
    state: { cards = [], selectedCardIndex = null },
    isEditMode,
    onChange,
    focused,
}) => {
    return (
        <>
            {cards?.length > 0 ? (
                <div className="flex flex-col md:flex-row content__rounded-card gap-[30px]">
                    {cards.map((card, idx) => {
                        return (
                            <div
                                key={`card_${idx}`}
                                style={{
                                    boxShadow:
                                        selectedCardIndex === idx &&
                                        focused &&
                                        "inset 0 0 0 3px red",
                                    backgroundImage: `url(${card.image})`,
                                    backgroundColor: card.backgroundColour,
                                }}
                                className={`flex flex-1 flex-col items-start mb-0 product-card p-[15px]  md:p-[30px] rounded-[5px] border relative bg-cover bg-center ${
                                    card.border
                                        ? "border-brand-grey"
                                        : "!border-transparent"
                                } overflow-hidden`}
                                onClick={(e) => {
                                    if (isEditMode) {
                                        e.preventDefault();
                                        onChange({ selectedCardIndex: idx });
                                    }
                                }}
                            >
                                <div className="flex flex-col items-start gap-[30px] h-full z-[20]">
                                    <div className="flex flex-col items-start flex-grow gap-[15px]">
                                        <h4
                                            className={`!text-[24px] !lg:text-[30px]  !leading-[28px] !lg:leading-36px]  !mb-0`}
                                            style={{
                                                color: card.headingColour,
                                            }}
                                        >
                                            {card.heading || ""}
                                        </h4>

                                        <p
                                            className="text-[16px] leading-[22px] mb-0 "
                                            style={{
                                                color: card.textColour,
                                            }}
                                        >
                                            {card.content || ""}
                                        </p>
                                    </div>

                                    {card.buttonText.length > 0 && (
                                        <button
                                            data-testid="text-on-image__button"
                                            variant="secondary"
                                            className={cn(
                                                "!border-transparent",
                                                buttonVariants.primary
                                                    .solidClasses
                                            )}
                                        >
                                            {card.buttonText || ""}
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <Icon />
            )}
        </>
    );
};

export default CardsComponent;
